import React from 'react';
import Shimmer from './Shimmer';

const TourismShimmer = () => (
    <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* En-tête de section */}
            <div className="text-center mb-16">
                <Shimmer className="h-10 w-2/3 max-w-xl mx-auto rounded mb-4"/>
                <Shimmer className="h-6 w-full max-w-2xl mx-auto rounded"/>
            </div>

            {/* Sections touristiques */}
            <div className="space-y-24">
                {[1, 2, 3].map((sectionIndex) => (
                    <div key={sectionIndex} className="relative">
                        {/* En-tête de section */}
                        <div className="flex items-center gap-4 mb-12">
                            <Shimmer className="w-16 h-16 rounded-full"/>
                            <div>
                                <Shimmer className="h-8 w-64 rounded mb-2"/>
                                <Shimmer className="h-4 w-96 rounded"/>
                            </div>
                        </div>

                        {/* Places */}
                        <div className="space-y-16">
                            {[1, 2].map((placeIndex) => (
                                <div key={placeIndex} className="group">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                                        {/* Image */}
                                        <div className="relative overflow-hidden">
                                            <Shimmer className="w-full h-[400px] rounded"/>
                                        </div>

                                        {/* Contenu */}
                                        <div className="flex flex-col justify-center">
                                            <Shimmer className="h-8 w-3/4 rounded mb-4"/>
                                            <Shimmer className="h-4 w-full rounded mb-2"/>
                                            <Shimmer className="h-4 w-full rounded mb-2"/>
                                            <Shimmer className="h-4 w-2/3 rounded mb-6"/>

                                            {/* Activités */}
                                            <div className="mb-6">
                                                <Shimmer className="h-6 w-32 rounded mb-2"/>
                                                <div className="flex flex-wrap gap-2">
                                                    {[1, 2, 3].map((actIndex) => (
                                                        <Shimmer
                                                            key={actIndex}
                                                            className="h-8 w-24 rounded"
                                                        />
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Informations supplémentaires */}
                                            <div className="flex flex-wrap gap-8">
                                                <Shimmer className="h-6 w-32 rounded"/>
                                                <Shimmer className="h-6 w-32 rounded"/>
                                                <Shimmer className="h-6 w-32 rounded"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Section CTA */}
            <div className="mt-24">
                <div className="bg-slate-100 py-16 px-8">
                    <div className="max-w-3xl mx-auto text-center">
                        <Shimmer className="h-8 w-96 mx-auto rounded mb-4"/>
                        <Shimmer className="h-6 w-full max-w-xl mx-auto rounded mb-8"/>
                        <div className="flex justify-center gap-4">
                            <Shimmer className="h-12 w-40 rounded"/>
                            <Shimmer className="h-12 w-40 rounded"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default TourismShimmer;